import { cva } from 'class-variance-authority'

export const rootStyles = cva(
  [
    'min-w-[300px]',
    'flex',
    'flex-col',
    'h-full',
    'min-h-screen',
    'background-app',
    'px-4',
    'py-4',
    'overflow-x-hidden',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
)

export const footerStyles = cva(
  ['mt-auto', 'pt-6', '-mx-4', 'px-4', 'flex', 'flex-col', 'gap-0.5'],
  {
    variants: {
      showShadow: {
        true: 'shadow-[0_-4px_12px_-2px_rgba(0,0,0,0.15)] [clip-path:inset(-20px_0_0_0)]',
      },
    },
  }
)

export const footerMenuStyles = cva([
  'flex',
  'items-center',
  'justify-between',
  'w-full',
  'h-8',
  'shrink-0',
  'pl-2',
  'pr-4',
  'border-none',
  // No explicit font-size: inherit the sidebar's 16px so FontAwesome icons
  // (sized as 1em) match the nav icons. The label sets its own size via Text.
  'leading-none',
  'hover:bg-neutral-50',
  'rounded-2xl',
  'cursor-pointer',
])

export const listStyles = cva(['flex', 'flex-col', 'p-0'])

export const listItemStyles = cva([
  'flex',
  'flex-row',
  'items-center',
  'px-2',
  'py-1.5',
  'mb-0',
  'cursor-pointer',
  'hover:bg-neutral-50',
  'rounded-2xl',
])

export const iconStyles = cva(['mr-2', 'h-4', 'w-4', 'flex-shrink-0'])

export const pageItemStyles = cva(
  ['p-0', 'border-none', 'cursor-pointer', 'w-full'],
  {
    variants: {
      disabled: {
        true: 'cursor-default',
      },
    },
  }
)

export const pageAccordionTriggerStyles = cva(
  `
  flex
  items-center
  justify-between
  w-full
  h-[38px]
  py-2
  pl-2
  pr-2
  hover:bg-neutral-50
  hover:rounded-[16px]
  rounded-[10px]
  cursor-pointer
  text-base
  `,
  {
    variants: {
      isActive: {
        true: 'bg-moss-50 rounded-[16px]',
      },
    },
  }
)

export const pageListItemStyles = cva(
  `
  flex
  items-center
  w-full
  h-9
  m-0
  hover:bg-neutral-50
  hover:rounded-[16px]
  rounded-[10px]
  cursor-pointer
  `,
  {
    variants: {
      isActive: {
        true: 'bg-moss-50 rounded-[16px]',
      },
    },
  }
)

export const pageDivItemStyles = cva(
  [
    'flex',
    'items-center',
    'h-[38px]',
    'border-none',
    'hover:bg-neutral-50',
    'hover:rounded-[16px]',
    'rounded-[10px]',
    'cursor-pointer',
  ],
  {
    variants: {
      isActive: {
        true: 'bg-moss-50 rounded-[16px]',
      },
    },
  }
)
